export interface PasswordValidationRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const passwordValidationRules: PasswordValidationRule[] = [
  {
    id: 'length',
    label: 'Mínimo 8 caracteres',
    test: (password) => password.length >= 8,
  },
  {
    id: 'lowercase',
    label: 'Uma letra minúscula',
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: 'uppercase',
    label: 'Uma letra maiúscula',
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: 'number',
    label: 'Um número',
    test: (password) => /[0-9]/.test(password),
  },
  {
    id: 'special',
    label: 'Um caractere especial',
    test: (password) => /[^a-zA-Z0-9]/.test(password),
  },
];

export function validatePassword(password: string): {
  isValid: boolean;
  failedRules: string[];
} {
  const failedRules = passwordValidationRules
    .filter((rule) => !rule.test(password))
    .map((rule) => rule.id);

  return {
    isValid: failedRules.length === 0,
    failedRules,
  };
}

export function getPasswordStrength(password: string): {
  score: number;
  label: string;
  color: string;
} {
  const { failedRules } = validatePassword(password);
  const passedRules = passwordValidationRules.length - failedRules.length;
  const score = (passedRules / passwordValidationRules.length) * 100;

  if (score === 0) {
    return { score: 0, label: 'Muito fraca', color: 'bg-red-500' };
  }
  if (score <= 20) {
    return { score: 20, label: 'Muito fraca', color: 'bg-red-500' };
  }
  if (score <= 40) {
    return { score: 40, label: 'Fraca', color: 'bg-orange-500' };
  }
  if (score <= 60) {
    return { score: 60, label: 'Média', color: 'bg-yellow-500' };
  }
  if (score <= 80) {
    return { score: 80, label: 'Forte', color: 'bg-lime-500' };
  }
  return { score: 100, label: 'Muito forte', color: 'bg-green-500' };
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isStrongPassword(password: string): boolean {
  const { isValid } = validatePassword(password);
  return isValid;
}
